var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCordinat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 77,
    viewBox: "0 0 58 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.6498 2.19934C22.5791 -2.32903 6.69089 6.21722 2.16251 21.2879C1.41388 23.7817 0.873354 26.3333 0.546506 28.9164C0.0726217 32.8352 0.053412 36.7956 0.489257 40.7188C2.29102 53.7493 7.38421 66.1056 15.2879 76.621C15.2879 76.621 48.2334 65.9916 56.7383 37.6866C58.9129 30.4494 58.1235 22.6448 54.5437 15.9896C50.9639 9.33445 44.887 4.37394 37.6498 2.19934ZM25.7234 41.8909C17.5031 39.4209 12.8415 30.7546 15.3115 22.5342C17.7815 14.3138 26.4478 9.65221 34.6682 12.1222C42.8886 14.5922 47.5502 23.2585 45.0801 31.4789C43.894 35.4265 41.1883 38.7412 37.5582 40.6938C33.9281 42.6464 29.671 43.077 25.7234 41.8909Z",
    fill: "#E64C3C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCordinat);
export default __webpack_public_path__ + "static/media/cordinat.fe2e5fa4a194eef340782865fed626ca.svg";
export { ForwardRef as ReactComponent };